<template>
    <div v-if="dataInstance">
        <div class="row">
            <div class="col-md-12 form-group">
                <h4 style="display: inline;">Who will {{isPayer ? "remit" : "receive"}} the payment?</h4>
            </div>
            <div class="col-md-12 form-group">
                <span v-for="pt in payeeTypes" :key="pt.id+String(isPayer)">
                    <input type="radio" :id="pt.id+String(isPayer)" :value="pt.id" v-model="payeeType">
                    <label :for="pt.id+String(isPayer)" style="padding-right: 35px;"> {{pt.title}} </label>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div v-show="payeeType===PAYEE_OPTIONS.SELF && !isPayer">
                    <div v-if="bankingInfoNeeded" class="alert alert-danger">
                        You need to setup your bank account information in order to proceed, click
                        <a :href="bankingInfoUrl">here</a>
                        to do so.
                    </div>
                </div>
                <div v-show="payeeType===PAYEE_OPTIONS.EXISTING">
                    <payee-selection :payee-form-instance="dataInstance" @onPayeeSelection="existingPayeeSelected">
                    </payee-selection>
                </div>
                <div v-show="payeeType===PAYEE_OPTIONS.NEW">
                    <payee-form ref="newPayeeForm" :isPayer="isPayer">
                    </payee-form>
                </div>
            </div>
        </div>
        <div class="row" v-if="hasValue(selectedPayeeName)">
            <div class="col-md-12">
                <div class="alert alert-info">
                    Payment will be sent {{isPayer ? "from" : "to"}} {{selectedPayeeName}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {PayeeFormClass} from "./PayeeFormClass.js";
    import {mapGetters} from 'vuex';
    import {common} from "../../../global/common.js";
    import PayeeSelection from "./PayeeSelection.vue";
    import PayeeForm from "./PayeeForm.vue";

    export default {
        name: "PayeeOptions",
        components: {PayeeForm, PayeeSelection},
        props: {
            isPayer: {type: [Boolean], default: false},
            excludeAccresa: {type: [Boolean], default: false},
            bankingInfoUrl: {type: [String], required: true}, 
            dataInstance: {type: [PayeeFormClass], required: false}
        },
        data() {
            return {
                selectedPayee: {},
                payeeType: common.PAYEE_OPTIONS.SELF,
                PAYEE_OPTIONS: common.PAYEE_OPTIONS
            };
        },
        computed: {
            ...mapGetters(['name', 'bankingInfoNeeded']),
            payeeTypes() {
                let types = [
                    {title: (this.isPayer ? 'Group' : 'Myself'), id: common.PAYEE_OPTIONS.SELF},
                    {title: 'Existing ' + (this.isPayer ? 'Payer' : 'Payee'), id: common.PAYEE_OPTIONS.EXISTING},
                    {title: 'New ' + (this.isPayer ? 'Payer' : 'Payee'), id: common.PAYEE_OPTIONS.NEW},
                ];
                
                if (!this.isPayer && !this.excludeAccresa) 
                    types.push({title: 'Accresa', id: common.PAYEE_OPTIONS.ACCRESA});

                return types;
            },
            selectedPayeeName() {
                if (this.payeeType === this.PAYEE_OPTIONS.SELF)
                    return this.isPayer ? "group" : this.name;
                else if (this.payeeType === this.PAYEE_OPTIONS.ACCRESA) {
                    return "Accresa";
                } else if (this.payeeType === this.PAYEE_OPTIONS.EXISTING) {
                    return this.hasValue(this.selectedPayee) ? this.selectedPayee.payeeName : '';
                }
                return '';
            }
        },
        methods: {
            existingPayeeSelected(selectedPayee) {
                this.mapData('selectedPayee', selectedPayee);
            },
            async getPayee() {
                if (this.payeeType === this.PAYEE_OPTIONS.SELF) {
                    if (!this.bankingInfoNeeded || this.isPayer) {
                        return {
                            isExternalPayee: false, 
                            isNew: false, 
                            displayName: this.isPayer ? "Group" : this.name, 
                            payeeOptionType: this.payeeType
                        };
                    }
                } else if (this.payeeType === this.PAYEE_OPTIONS.EXISTING) {
                    if (this.hasValue(this.selectedPayee)) {
                        return {
                            ...this.selectedPayee,
                            isNew: false, 
                            displayName: this.selectedPayee.payeeName, 
                            payeeOptionType: this.payeeType
                        };
                    }
                } else if (this.payeeType === this.PAYEE_OPTIONS.NEW) {
                    let result = await this.$refs.newPayeeForm.getPayee();
                    if (result) {
                        return {
                            ...result, 
                            isExternalPayee: true, 
                            isNew: true, 
                            displayName: result.name, 
                            payeeOptionType: this.payeeType
                        };
                    }
                } else if (this.payeeType === this.PAYEE_OPTIONS.ACCRESA) {
                    return {
                        isExternalPayee: false, 
                        isNew: false, 
                        displayName: 'Accresa', 
                        payeeOptionType: this.payeeType
                    };
                }
                return null;
            }
        }
    }
</script>

<style scoped>

</style>